const initialState = {
  list: [],
  rowsCount: 0,
  loading: 'idle',
};

export default initialState;
